import { MdAttachMoney, MdHighlightOff } from "react-icons/md";
import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import Card from "components/card/custom";
import { toast } from "react-hot-toast";
import React, { useEffect, useState } from "react";
import DivLoader from "components/divloader/DivLoader";
import { getClientTreasury , createClientTreasury} from "api/graphQL_clients";
import moment from "moment";
import {
    PaginationState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from "@tanstack/react-table";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { getCurrencySymbol, currencyCodes } from "utils/currencyList"; 
import { Select as AntSelect } from "antd";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

export interface TreasuryRowObj {
    client_id:any;
    gateway_id:any;
    amount: any;
    type:any;
    description:any;
    currency_code:any;
    created_at:any;
}

const AddTreasury = ({
  id,
  fetchClients,
  roleData
}: {
  id: string;
  fetchClients: () => void;
  roleData?: any;
}) => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isLoading, setIsLoading] = useState<boolean>();
    const [isAddLoading, setIsAddLoading] = useState<boolean>();
    const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
    const [allTreasury,setAllTreasury] = useState([])
    const [totalTreasury,setTotalTreasury] = useState([])
    const [amount,setAmount] = useState("")
    const [data, setData] = useState([]);
    const [description,setDescription] = useState("")
    const [currency,setCurrency] = useState(null)
    const [pageSize, setPageSize] = useState<number>(50);
    const [sorting, setSorting] = React.useState<SortingState>([]);
    const [amountError,setAmountError] = useState("")
    const [descriptionError,setDescriptionError] = useState("")
    const [currencyError,setCurrencyError] = useState("")
    const [searchCurrency,setCurrencySearch] = useState(null)

    const fetchTreasury = async () => {
        setIsLoading(true);
        getClientTreasury(id,searchCurrency)
        .then((data) => {
            setAllTreasury(data[0].treasury)
            setTotalTreasury(data[0].total_treasury)
        })
        .catch((err) => {
            toast.error(
                err?.response?.data?.message ??
                "Something went wrong while fetching client treasury"
            );
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {    
        setData(allTreasury);
    }, [allTreasury]);

    const [{ pageIndex }, setPagination] = React.useState<PaginationState>({
        pageIndex: 0,
        pageSize,
    });

    const pagination = React.useMemo(() => ({
        pageIndex,
        pageSize,
    }), [pageIndex, pageSize],);

    const columns = [
        columnHelper.accessor("created_at", {
            id: "created_at",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
            ),
            cell: (info : any) => {
                const rawDate = info.getValue();
                const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {formattedDate}
                        </p>
                    </div>
                </>
            },  
            size: 200, 
            minSize: 200,
            maxSize: 300,  
        }),
        columnHelper.accessor("description", {
            id: "description",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Description</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            { info.getValue()}
                        </p>
                    </div>
                </>
            },  
            size: 200, 
            minSize: 200,
            maxSize: 300,  
        }),
        columnHelper.accessor("amount", {
            id: "amount",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Amount</p>
            ),
            cell: (info : any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {Number(info?.getValue() ?? 0).toFixed(2)} {info.row.original.currencyCode} {" "} {info.row.original.type === 'credit' ? "(+)" : "(-)"}
                        </p>
                    </div>
                </>
            },  
            size: 200, 
            minSize: 200,
            maxSize: 300,  
        })
    ]

    const table = useReactTable({
        data,
        columns:columns,
        state: {
            pagination,
            sorting,
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
    });

    const hanldleCurrenyChange = (e:any) => {
        const value = e
        setCurrency(value);
        if (value === "" || value === null) {
            setCurrencyError("The field is required");
        } else {
            setCurrencyError("");
        }
    }

    const hanldleSearchCurrenyChange = (e:any) => {
        const value = e
        setCurrencySearch(value);
    }

    const handleClose = () => {
        setIsCloseModal(true)
        setAllTreasury([])
        setData([])
        setTotalTreasury([])
        setAmount("")
        setDescription("")
        setCurrency(null)
        setCurrencySearch(null)
        setAmountError("")
        setDescriptionError("")
        setCurrencyError("")
        setTimeout(() => {
        setIsCloseModal(false)
        onClose();
        }, 300);
    };

    const validateData = () => {
        let valid = true;
        if (amount === "") {
            setAmountError("The field is required");
            valid = false;
        } else {
            setAmountError("");
        }
        if (description === "") {
            setDescriptionError("The field is required");
            valid = false;
        } else {
            setDescriptionError("");
        }
        if (currency === "" || currency === null) {
            setCurrencyError("The field is required");
            valid = false;
        } else {
            setCurrencyError("");
        }
        return valid;
    };


    const handleAdd = () => {
        const isValid  = validateData();
        if(isValid ) {
            setIsAddLoading(true);
            createClientTreasury(id,amount,description,currency)
            .then((data) => {
                if(data[0].status == "Error") {
                    toast.error(data[0].message)
                } else {
                    toast.success(data[0].message)
                    // fetchTreasury()
                    setCurrencySearch(null)
                    setAllTreasury([])
                    setTotalTreasury([])
                    setAmount("")
                    setDescription("")
                    setCurrency(null)
                    setAmountError("")
                    setDescriptionError("")
                    setCurrencyError("")
                    setCurrencySearch(null)
                }
            })
            .catch((err) => {
                toast.error(
                    err?.response?.data?.message ??
                    "Something went wrong while fetching client treasury"
                );
            })
            .finally(() => {
                setIsAddLoading(false);
            });
        }
    }

    useEffect(() => {
        if(searchCurrency) {
            fetchTreasury();
        }
    },[searchCurrency])

    return (
        <>
        <Popover trigger="hover" placement="bottom">
            <PopoverTrigger>
                <button
                    className="outline-none text-blue-500"
                >
                    <MdAttachMoney
                        className="h-5 w-5 cursor-pointer"
                        onClick={() => {
                            onOpen();
                        }}
                        />
                </button>
            </PopoverTrigger>  
            {/* <Portal >  */}
            <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                <PopoverHeader>
                <span className="text-sm  font-bold text-white">
                Add Client Treasury
                </span>
                </PopoverHeader>
                <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
            </PopoverContent>
            {/* </Portal> */}
        </Popover>
        
        <Modal isOpen={isOpen} onClose={() => {}}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
            isOpen && !isCloseModal ? "card-enter" : "card-exit"
            }`}>
                <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                    <MdHighlightOff
                        className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                        onClick={handleClose}
                    />
                    Add Treasury
                </ModalHeader> 
                 <ModalBody className="p-4">
                    {roleData[0]?.client?.value?.add_client_treasury && (
                        <div className="px-[10px]">
                            <div className="">
                                <label
                                    htmlFor="name-input"
                                    className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                                >
                                    Amount <span className="important">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="block w-full rounded-lg border p-2.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                                    placeholder="Enter Amount"
                                    value={amount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                            setAmount(value);
                                            if (value === "") {
                                                setAmountError("The field is required");
                                            } else {
                                                setAmountError("");
                                            }
                                        }
                                    }}
                                />
                                <div className="my-2 text-orange-500">
                                    {amountError}
                                </div>
                            </div>
                            <div className="mt-2">
                                <label
                                    htmlFor="name-input"
                                    className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                                > 
                                    Description <span className="important">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="block w-full rounded-lg border p-2.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                                    placeholder="Enter Description"
                                    value={description}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setDescription(value);
                                        if (value === "") {
                                            setDescriptionError("The field is required");
                                        } else {
                                            setDescriptionError("");
                                        }
                                    }}
                                />
                                <div className="my-2 text-orange-500">
                                    {descriptionError}
                                </div>
                            </div>
                            <div className="">
                                <label
                                    htmlFor="name-input"
                                    className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                                >
                                    Currency <span className="important">*</span>
                                </label>
                                <AntSelect
                                    showSearch
                                    placeholder="Select currency"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").includes(
                                        input?.toUpperCase()
                                        )
                                    }
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? "")
                                        .toLowerCase()
                                        .localeCompare(
                                            (
                                            optionB?.label ?? ""
                                            ).toLowerCase()
                                        )
                                    }
                                    className="w-full"
                                    options={currencyCodes.map(
                                        (currencyCode) => {
                                        const currencyDetails =
                                            getCurrencySymbol(currencyCode);
                                        return {
                                            value: currencyCode,
                                            label: `${currencyCode}: ${currencyDetails.title?.toUpperCase()}`,
                                        };
                                        }
                                    )}
                                    onChange={(e) => {
                                        hanldleCurrenyChange(
                                        e,
                                        );
                                    }}
                                    value={currency}
                                    notFoundContent={"No options found"}
                                />
                                <div className="my-2 text-orange-500">
                                    { currencyError}
                                </div>
                            </div>
                            <div className="mt-3 flex justify-end gap-2">
                                <button
                                    onClick={handleAdd}
                                    className="linear rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                                >
                                    {isAddLoading ? (
                                    <DivLoader className="h-6 w-6 border-white" />
                                    ) : (
                                    "Add"
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="px-[10px] mt-3 mb-3">
                        <label
                            htmlFor="name-input"
                            className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                        >
                            Select Currency To Fetch Treasury
                        </label>
                        <AntSelect
                            showSearch
                            placeholder="Select currency"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? "").includes(
                                input?.toUpperCase()
                                )
                            }
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                    (
                                    optionB?.label ?? ""
                                    ).toLowerCase()
                                )
                            }
                            className="w-full"
                            options={currencyCodes.map(
                                (currencyCode) => {
                                const currencyDetails =
                                    getCurrencySymbol(currencyCode);
                                return {
                                    value: currencyCode,
                                    label: `${currencyCode}: ${currencyDetails.title?.toUpperCase()}`,
                                };
                                }
                            )}
                            onChange={(e) => {
                                hanldleSearchCurrenyChange(e);
                            }}
                            value={searchCurrency}
                            notFoundContent={"No options found"}
                        />
                    </div>
                    {isLoading ? (
                        <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                    ) : (
                        <div className="px-[10px] mt-[20px]">
                            <div className="relative mt-4 overflow-x-auto overflow-x-auto shadow-md scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg">
                                <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                        {table.getHeaderGroups().map((headerGroup) => (
                                            <tr key={headerGroup.id} className="">
                                                {headerGroup.headers.map((header) => {
                                                    return (
                                                        <th
                                                            key={header.id}
                                                            colSpan={header.colSpan}
                                                            onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                                            className={`border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2 ${header.column.getCanSort() ? 'cursor-pointer' : ''}`}
                                                        >
                                                            <div className="flex items-center text-xs text-gray-200">
                                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                                            {header.column.getCanSort() && (
                                                                <span className="ml-2">
                                                                    {header.column.getIsSorted() === "asc" ? (
                                                                    <BsArrowUp size={14} className="text-gray-900"/>
                                                                    ) : header.column.getIsSorted() === "desc" ? (
                                                                    <BsArrowDown size={14} className="text-gray-900"/>
                                                                    ) : (
                                                                    <RiArrowUpDownFill size={14} className="text-gray-900"/>
                                                                    )}
                                                                </span>
                                                            )}
                                                            </div>
                                                        </th>
                                                    )
                                                })}
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody >
                                        {(table.getRowModel().rows?.length > 0) ? (
                                            <>
                                                {table.getRowModel().rows.map((row) => (
                                                    <React.Fragment key={row.id}>
                                                    <tr
                                                        key={row.id}
                                                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                                                    >
                                                        {row.getVisibleCells().map((cell) => (
                                                        <td
                                                            key={cell.id}
                                                            className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900"
                                                        >
                                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                        </td>
                                                        ))}
                                                    </tr>
                                                    </React.Fragment>
                                                ))}
                                                <tr className="bg-gray-50 dark:bg-gray-700">
                                                    <td colSpan={2} className="py-3 uppercase px-4 text-right font-bold text-gray-900 dark:text-white">
                                                        Total Treasury:
                                                    </td>
                                                    <td className="py-3 px-4 font-bold text-gray-900 dark:text-white">
                                                        {Number(totalTreasury).toFixed(2)} {searchCurrency}
                                                    </td>
                                                </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={6}>
                                                    <p className="text-center p-4">No records found.</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </ModalBody>
                
            </Card>
        </Modal>
        </>
    )
}

export default AddTreasury;
const columnHelper = createColumnHelper<TreasuryRowObj>();

